import { render, staticRenderFns } from "./DevolucionesComponent.vue?vue&type=template&id=71528c94"
import script from "./DevolucionesComponent.vue?vue&type=script&lang=js"
export * from "./DevolucionesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports